import React from 'react'
import { Film } from 'lucide-react'
import { Position } from '@xyflow/react'
import { SparkleLoader } from '../../../common/SparkleLoader'
import {
  CollapsedWrapper,
  CollapsedViewWrapper,
  CollapsedCircle,
  CollapsedTargetHandle,
} from '../styles/StoryboardNodeStyles'

interface StoryboardCollapsedViewProps {
  zoomScaleRaw: number
  isGenerating: boolean
  onClickNode: () => void
}

export const StoryboardCollapsedView = React.memo(
  ({ zoomScaleRaw, isGenerating, onClickNode }: StoryboardCollapsedViewProps) => (
    <CollapsedWrapper $zoomScaleRaw={zoomScaleRaw}>
      <CollapsedViewWrapper>
        <CollapsedCircle onClick={onClickNode} $isGenerating={isGenerating}>
          {isGenerating ? (
            <SparkleLoader isAnimating={true} size={24} />
          ) : (
            <Film size={16} strokeWidth={2} />
          )}
        </CollapsedCircle>
        <CollapsedTargetHandle
          type="target"
          position={Position.Left}
          id="target"
          isConnectable={false}
        />
      </CollapsedViewWrapper>
    </CollapsedWrapper>
  )
)

StoryboardCollapsedView.displayName = 'StoryboardCollapsedView'
